import { render, staticRenderFns } from "./TxRowActionBadgeMobile.vue?vue&type=template&id=9b934e3c"
import script from "./TxRowActionBadgeMobile.vue?vue&type=script&lang=js"
export * from "./TxRowActionBadgeMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports